/* Velora: várható érkezés ("Várható érkezés: szerda, október 14.").
   A rendelés napját nem számoljuk; N munkanapot adunk hozzá (Budapest idő szerint).
   Munkanap: hétfő-péntek, nem magyar ünnep, nem szerepel a beállított zárt napok között.
   Minden [data-velora-eta] elemet kitölt (betöltéskor, kosárváltozáskor, új elemeknél). Idempotens. */
(() => {
  'use strict';

  const TZ = 'Europe/Budapest';
  const WEEKDAYS = ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'];
  const MONTHS = ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember', 'október', 'november', 'december'];
  const DAY = 86400000;

  const key = (y, m, d) => y + '-' + String(m).padStart(2, '0') + '-' + String(d).padStart(2, '0');
  const utc = (y, m, d) => new Date(Date.UTC(y, m - 1, d));
  const keyOf = date => key(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());

  function easter(year) {
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return utc(year, month, day);
  }

  const holidayCache = {};
  function holidays(year) {
    if (holidayCache[year]) return holidayCache[year];
    const set = new Set([[1, 1], [3, 15], [5, 1], [8, 20], [10, 23], [11, 1], [12, 24], [12, 25], [12, 26]].map(([m, d]) => key(year, m, d)));
    const e = easter(year);
    [-2, 1, 50].forEach(n => set.add(keyOf(new Date(e.getTime() + n * DAY))));
    return (holidayCache[year] = set);
  }

  function parseClosed(value) {
    const set = new Set();
    String(value || '').split(',').forEach(part => {
      const m = part.trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
      if (m) set.add(key(+m[1], +m[2], +m[3]));
    });
    return set;
  }

  const isBusinessDay = (date, closed) => {
    const dow = date.getUTCDay();
    return dow !== 0 && dow !== 6 && !holidays(date.getUTCFullYear()).has(keyOf(date)) && !closed.has(keyOf(date));
  };

  // Budapest jelenlegi dátuma és órája.
  function budapestNow(now) {
    const parts = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' })
      .formatToParts(now).forEach(p => { parts[p.type] = p.value; });
    return { date: utc(+parts.year, +parts.month, +parts.day), hour: +parts.hour };
  }

  // Visszaadja az érkezés napját (UTC-éjfélre állított Date), és hogy holnap van-e.
  function compute(now, opts) {
    opts = opts || {};
    const days = Math.max(0, Math.floor(Number(opts.days)) || 2);
    const cutoff = Math.floor(Number(opts.cutoffHour)) || 0;
    const closed = parseClosed(opts.closedDates);
    const bp = budapestNow(now || new Date());
    let cur = new Date(bp.date.getTime());
    let remaining = days;
    // Orders after the cutoff, or on a non-business day, ship on the next business day.
    if (cutoff > 0 && (bp.hour >= cutoff || !isBusinessDay(cur, closed))) remaining += 1;
    let guard = 0;
    while (remaining > 0 && guard++ < 60) {
      cur = new Date(cur.getTime() + DAY);
      if (isBusinessDay(cur, closed)) remaining -= 1;
    }
    return { date: cur, tomorrow: cur.getTime() - bp.date.getTime() === DAY };
  }

  function format(result) {
    const d = result.date;
    const text = MONTHS[d.getUTCMonth()] + ' ' + d.getUTCDate() + '.';
    return { label: 'Várható érkezés: ', date: WEEKDAYS[d.getUTCDay()] + ', ' + text };
  }


  function fill(root) {
    const cfg = (window.veloraConfig && window.veloraConfig.eta) || null;
    if (!cfg || cfg.enabled === false) return;
    const nodes = (root || document).querySelectorAll('[data-velora-eta]');
    if (!nodes.length) return;
    let parts;
    try { parts = format(compute(new Date(), cfg)); } catch (e) { return; }
    const label = parts.label + parts.date;
    nodes.forEach(node => {
      if (node.getAttribute('data-velora-eta-text') === label && node.firstChild) return;
      node.innerHTML = '<span></span>';
      node.lastChild.appendChild(document.createTextNode(parts.label));
      const strong = document.createElement('strong');
      strong.textContent = parts.date;
      node.lastChild.appendChild(strong);
      node.setAttribute('data-velora-eta-text', label);
    });
  }

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    setTimeout(() => { queued = false; fill(); }, 0);
  };

  if (typeof window !== 'undefined') window.VeloraEta = { compute, format, fill };
  if (typeof module !== 'undefined' && module.exports) module.exports = { compute, format };
  if (typeof document === 'undefined') return;

  const start = () => {
    fill();
    document.addEventListener('velora:cart-changed', schedule);
    // Vissza gomb (bfcache): a nap változhatott, számoljuk újra.
    window.addEventListener('pageshow', () => { queued = false; fill(); setTimeout(fill, 1500); });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      try { subscribe(PUB_SUB_EVENTS.cartUpdate, schedule); } catch (e) { /* nincs pub/sub */ }
    }
    // Új (üres) helyőrzők a szekciók újrarajzolása után.
    new MutationObserver(mutations => {
      for (const m of mutations) {
        for (const n of m.addedNodes) {
          if (n.nodeType === 1 && (n.hasAttribute('data-velora-eta') || n.querySelector('[data-velora-eta]'))) { schedule(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
